"use strict";

exports.__esModule = true;
exports.default = void 0;

var _modal = _interopRequireDefault(require("./modal"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var directives = {
  BModal: _modal.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/modal/index.js
// module id = 449
// module chunks = 0